import Component from './Header.vue';

export default {
  install(Vue) {
    Vue.component('BkfCardHeader', Component);
  },
};
